import CloseIcon from "@mui/icons-material/Close";
import {
  Chip,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemSecondaryAction,
  ListItemText,
  Modal,
  Stack,
  Typography,
  styled,
} from "@mui/material";
import React, { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { KEYBOARD_SHORTCUTS } from "../constants";
import useKeyboardActions from "../hooks/useKeyboardActions";
import { onToggleShowKeyboardActions } from "../store/toolbar";

const style = {
  height: 500,
  width: 800,
  maxWidth: "70%",
  maxHeight: "70%",
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  boxShadow: theme.shadows[1],
}));

const KeyboardActions: React.FC<{}> = () => {
  const dispatch = useAppDispatch();

  const isOpen = useAppSelector(
    (state) => state.developer.edit.toolbar.showKeyboardActions
  );

  const handleClose = useCallback(() => {
    dispatch(onToggleShowKeyboardActions(false));
  }, [dispatch]);

  useKeyboardActions();

  const sections = Object.keys(KEYBOARD_SHORTCUTS);

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Stack sx={style} spacing={2}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Keyboard Shortcuts
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Divider variant="fullWidth" />
        <Stack direction="row" spacing={2}>
          {sections.map((section) => (
            <Stack width={1 / 2} key={section}>
              <Stack>
                <Typography variant="subtitle1" fontWeight="bolder">
                  {section}
                </Typography>
                <List dense>
                  {KEYBOARD_SHORTCUTS[section].map((item) => (
                    <ListItem disablePadding divider key={item.title}>
                      <ListItemButton>
                        <ListItemText primary={item.title} />
                        <ListItemSecondaryAction>
                          <Stack direction="row" spacing={1}>
                            {item.command.split("+").map((key) => (
                              <StyledChip key={key} label={key} size="small" />
                            ))}
                          </Stack>
                        </ListItemSecondaryAction>
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Modal>
  );
};

export default KeyboardActions;
